const PrimaryButton = (props) => {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <a
        href="https://ikarus3d.com/contact-us"
        className={`h-fit xl:h-12 w-full tab:w-auto flex text-button-sm md:text-button-lg xl:text-button-xl font-[400] tab:font-[500] xl:font-[400] tab:min-w-[8.25rem] text-center justify-center items-center px-[18px] tab:px-8 tab:py-[11px] lg:px-6 py-[10px] lg:py-3 xxl:py-[19px] shadow-xs rounded-[5px]`}
        style={{
          backgroundColor: props.bgColor ? props.bgColor : "",
          background: !props.bgColor
            ? "linear-gradient(to right, #015EF1, #489BE1)"
            : "",
          color: props.textColor ? props.textColor : "white",
        }}
      >
        {props.content}
      </a>
    </div>
  );
};

export default PrimaryButton;
